import { STRIPE_KEY } from "src/app/config";
// eslint-disable-next-line no-undef
const stripe = new Stripe(STRIPE_KEY);
export default stripe;
